export default __webpack_public_path__ + "static/media/logo-primary.66284699.svg";